var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "选择数据项",
        "close-on-click-modal": false,
        visible: _vm.visible,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.dataListLoading,
              expression: "dataListLoading",
            },
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.dataList,
            "row-key": "id",
            border: "",
            stripe: "",
          },
          on: { "selection-change": _vm.selectionChangeHandle },
        },
        [
          _c("el-table-column", {
            attrs: { type: "selection", fixed: "", width: "55" },
          }),
          _c("el-table-column", {
            attrs: {
              fixed: "",
              type: "index",
              "header-align": "left",
              align: "left",
              label: "序号",
              width: "60",
              index: _vm.getRowsIndex,
            },
          }),
          _c("el-table-column", {
            attrs: {
              fixed: "",
              prop: "datasetCode",
              "header-align": "left",
              align: "left",
              label: "数据集编号",
            },
          }),
          _c("el-table-column", {
            attrs: {
              fixed: "",
              prop: "columnName",
              "header-align": "left",
              align: "left",
              label: "字段名称",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "displayName",
              "header-align": "left",
              align: "left",
              label: "显示名称",
            },
          }),
        ],
        1
      ),
      _c("el-pagination", {
        attrs: {
          "current-page": _vm.pageIndex,
          "page-sizes": [10, 20, 50, 100],
          "page-size": _vm.pageSize,
          total: _vm.totalCount,
          layout: "total, sizes, prev, pager, next, jumper",
        },
        on: {
          "size-change": _vm.sizeChangeHandle,
          "current-change": _vm.currentChangeHandle,
        },
      }),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.dataFormSubmit()
                },
              },
            },
            [_vm._v("确定")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }